<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row :gutter="20">
            <!--职责-->
            <!--<el-col :span="6">
                            <el-form-item label="评分模块" prop="duty">
                                <el-select v-model="queryCondition.duty" clearable @change="queryCateGory">
                                    <el-option :key="index" v-for="(item,index) in dutyList"
                                               :label="item.duty" :value="item.duty"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>-->
            <!--评分大类-->
            <el-col :span="6">
              <el-form-item :label="$t('spm.dcName')" prop="bigName">
                <el-select v-model="queryCondition.bigName" clearable style="width:100%">
                  <el-option :key="index" v-for="(item,index) in cateGoryList" :label="item.name" :value="item.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!--评分项-->
            <el-col :span="6">
              <el-form-item :label="$t('spm.dcStatus')" prop="smallName">
                <el-input v-model.trim="queryCondition.smallName" clearable style="width:100%"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm()" type="primary">{{$t('common.reset')}}</el-button>
          </el-row>
        </el-form>
      </div>
      <!--=========查询模块END================-->
      <el-row class="action-btn-row">
        <el-button size="mini" class="btn" type="primary" @click="showDialogMethod('add')" v-acl="SaveTemplate">{{$t('common.addNew')}}</el-button>
        <el-button size="mini" class="btn" type="danger" @click="deleteRow" v-acl="DeleteTemplate">{{$t('common.del')}}</el-button>
        <!--<el-button type="primary" @click="getTemplate">{{$t('spm.createTemp')}}</el-button>-->
      </el-row>
      <!--=========数据列表================-->

      <el-table max-height="435" :data="tableData" ref="tableData" border highlight-current-row class="table">
        <el-table-column align="center" width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.row.categoryId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <!--<el-table-column prop="duty" label="评分模块">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="showDialogMethod('update',scope.row)"> {{scope.row.duty}}
                        </el-link>
                    </template>
                </el-table-column>-->
        <el-table-column show-overflow-tooltip prop="bigName" :label="$t('spm.dcName')" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="bigScore" :label="$t('spm.specUpload')" min-width="80px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="smallName" :label="$t('spm.dcStatus')" min-width="200px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="smallScore" :label="$t('spm.smallScore')" min-width="80px"></el-table-column>
        <el-table-column show-overflow-tooltip prop="remark" :label="$t('spm.rfpInitiate')" min-width="350px"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>
    </div>
    <!--=========数据列表END================-->
    <!--=========添加/修改=========-->
    <el-dialog :title="$t('common.operation')" :visible.sync="showDialog" width="600px">
      <el-form :model="info" ref="infoForm" class="form_border" :rules="rules" :label-position="labelPosition" label-width="120px">
        <el-row type="flex" justify="space-around">
          <el-col :span="20">
            <!--<el-form-item label="评分模块" prop="duty">
                            <el-select v-model="info.duty" clearable @change="infoQueryCateGory">
                                <el-option :key="index" v-for="(item,index) in dutyList"
                                           :label="item.duty" :value="item.duty"></el-option>
                            </el-select>
                        </el-form-item>-->
            <el-form-item :label="$t('spm.dcName')" prop="bigName">
              <el-select v-model="info.pid" clearable>
                <el-option :key="index" v-for="(item,index) in cateGoryList" :label="item.name" :value="item.pid"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item :label="$t('spm.dcStatus')" prop="smallName">
              <el-input v-model="info.smallName" class="handle-input" />
            </el-form-item>
            <el-form-item :label="$t('spm.smallScore')" prop="smallScore">
              <el-input v-model="info.smallScore" class="handle-input" />
            </el-form-item>

            <el-form-item :label="$t('spm.rfpInitiate')" prop="remark">
              <el-input type="textarea" v-model="info.remark" class="handle-input" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" align="center">
        <el-button type="primary" size="mini" @click="showDialog = false">{{$t('common.close')}}</el-button>
        <el-button type="primary" size="mini" @click="saveOrUpdate" v-acl="SaveTemplate">{{$t('common.saveDraft')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { apiService } from "@/api/spm/spm-template";
import commonFunction from "@/utils/dataTableUtils"
import { Message } from "element-ui";

export default {
  name: 'spm-template',
  data() {
    return {
      totalCount: 0,
      tableData: [],
      labelPosition: 'right',
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        duty: null,
        bigName: null,
        smallName: null
      },
      showDialog: false,
      info: { duty: null, pid: null, smallName: null, remark: null },
      method: "",
      rules: {
        /*duty: [
            {required: true, message: '请选择评分模块', trigger: 'change'}
        ],*/
        pid: [
          { required: true, message: '请选择评分大类', trigger: 'change' }
        ],
        smallName: [
          { required: true, message: '请填写评分项', trigger: 'blur' }
        ],
        smallScore: [
          { required: true, message: '请填写评分项', trigger: 'blur' }
        ],
      },
      dutyList: [],// 评分模块下拉
      cateGoryList: [],//评分大类下拉
      infoCateGoryList: [],//info评分大类下拉
      radioVal: null,
    }
  },
  created() {
    this.queryData(1);
    // this.queryDuty();
    this.queryCateGory();
  },
  methods: {
    queryData(val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      apiService.search(this.queryCondition).then((res) => {
        this.tableData = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    restQueryForm() {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        duty: null,
        bigName: null,
        smallName: null
      }
      this.queryData()
    },
    /*queryDuty() {
        apiService.queryDuty().then((res) => {
            this.dutyList = res.data;
        });
    },*/
    queryCateGory() {
      this.cateGoryList = []
      apiService.queryCateGory().then((res) => {
        this.cateGoryList = res.data;
      });
    },
    showDialogMethod: function (method, row) {
      this.clearVlidate("infoForm");
      this.method = method;
      if ('add' === method) {
        this.info = {};
      } else {
        this.info = row;
      }
      this.showDialog = true;
    },
    saveOrUpdate: function () {
      let validFlag = false;
      this.$refs['infoForm'].validate((valid) => {
        validFlag = valid;
      });
      if (!validFlag) {
        return;
      }
      apiService.toAddOrUpdate(this.info).then((res) => {
        if (res.data.code === '200') {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
          this.showDialog = false;
          this.queryData();
        } else {
          Message({ message: res.msg, type: "error" });
        }
      });
    },
    deleteRow: function () {
      if (!!this.radioVal) {
        //请确认是否删除!
        this.$confirm(this.$t('common.delConfirm'), this.$t('common.tips'), {
          confirmButtonText: this.$t('common.confirm'),
          cancelButtonText: this.$t('common.cancel'),
          cancelButtonClass: 'el-button--primary',
          confirmButtonClass: 'el-button--primary',
          type: 'warning'
        }).then(() => {
          apiService.deleteById(this.radioVal).then((res) => {
            if (res.data.code === '200') {
              Message({ message: this.$t('common.delSuccess'), type: "success" });
              this.queryData();
            } else {
              Message({ message: res.meta.msg, type: "error" });
              this.queryData();
            }
            this.radioVal = null
          });
        }).catch(() => {

        });
      } else {
        Message({ message: '请选择需要删除的数据', type: "error" });
      }
    },
    //生成模板
    getTemplate() {
      apiService.getTemplate(this.queryCondition).then((res) => {
        if (res.data.code === '200') {
          Message({ message: this.$t('common.operateSuccess'), type: "success" });
        } else {
          Message({ message: res.meta.msg, type: "error" });
        }
      });
    },
    //清除校验信息
    clearVlidate: function (refFormName) {
      if (this.$refs[refFormName]) {
        this.$refs[refFormName].clearValidate();
      }
    },

  },
  extends: commonFunction
}
</script>
<style scoped>
.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}
</style>
